import { applyMiddleware, compose, createStore, combineReducers } from 'redux';

import { createReduxHistoryContext } from 'redux-first-history';
import { createBrowserHistory } from 'history';


import {
	LOADER_GLOBAL_SHOW,
	LOADER_GLOBAL_HIDE,
	SET_MAP_LOADED,
	SET_MAP_UNLOADED,
	SET_JSON_LOADED,
	RESIZE_WINDOW,
	ORIENTATION_CHANGE,
	TOGGLE_PANEL_DETAIL_OPEN,
	TOGGLE_PANEL_DETAIL_IS_OPEN,
	TOGGLE_PANEL_LEFT_OPEN,
	TOGGLE_PANEL_LEFT_IS_OPEN,
	TOGGLE_PANEL_DETAIL_CONTENT_IS_OPEN,
	TOGGLE_PANEL_START_OVERLAY_OPEN,
	TOGGLE_PANEL_START_OVERLAY_IS_OPEN,
	TOGGLE_PANEL_FULL_OVERLAY_AUTOCOMPLETE_NORESULT_IS_OPEN,
	TOGGLE_INSTANCE_AUTOCOMPLETE_MAIN_HEADER_OPEN,
	SET_PANEL_HEADER_HEIGHT,
	TOGGLE_INSTANCE_AUTOCOMPLETE_PANEL_LEFT_OPEN,
	TOGGLE_INSTANCE_AUTOCOMPLETE_START_OVERLAY_OPEN, TOGGLE_INSTANCE_AUTOCOMPLETE_PANEL_DETAIL_STATION_OPEN,
	INTERN_SET_IS_INITIAL_CONFIG_REQUEST_DONE,
	INTERN_SET_IS_AUTHENTICATED,
	INTERN_TOGGLE_PANEL_LEFT_OPEN,
	INTERN_TOGGLE_MODAL_COLOR_OPEN,
	INTERN_TOGGLE_MODAL_ORIGIN_DESTINATION_OPEN,
	INTERN_TOGGLE_SHOW_SMALL_STATION_LABELS,
	INTERN_TOOGLE_SHOW_MEDIUM_STATION_LABELS,
	INTERN_TOGGLE_SHOW_LARGE_STATION_LABELS,
	INTERN_TOGGLE_SHOW_LINE_LABELS,
	INTERN_TOGGLE_OVERRIDE_COLOR,
	INTERN_SET_ORIGIN_STATION_CODE,
	INTERN_RESET_ALL
} from './actions';

const initial_state = {
	ui: { // ui related unspecific
		loader_global_show_count: 0, // indicates if the global loader is shown > 0, or hidden = 0
		window_width: 0,
		window_height: 0,
		orientation: undefined,
		client_type: 'desktop' // mobile | tablet | desktop -> see breakpoints in AppConfig
	},
	panels: { // panels
		panel_detail_open: false, // indicates if the detail panel should open -> start open transition
		panel_detail_is_open: false, // is open -> end transition
		panel_detail_space: 0, // width or height in px, used to see if objects on map are overlapped by it
		panel_left_open: false, // indicates if the left panel should open > start open transition
		panel_left_is_open: false, // is open -> end transition
		panel_left_space: 0, // width/height in px, used to see if objects on map are overlapped by it
		panel_header_height: 0, // height of the header panel
        panel_detail_content_is_open: true, // mobile default: show basetact, not map
        panel_start_overlay_open: false, // Intro on Home fade in
        panel_start_overlay_is_open: false, // Intro on Home on Transition End
        panel_full_overlay_autocomplete_noresult_is_open: false, // Full Overlay for Dialog (eg. autocomplete -> no result found for string 'jahsgdjsd')
	},
	instances_open: { // open instances
		autocomplete_main_header: false, // indicates if the autocomplete should open
		autocomplete_panel_left: false, // indicates if the autocomplete should open
		autocomplete_start_overlay: false, // indicates if the autocomplete should open
		autocomplete_panel_detail_station: false, // indicates if the autocomplete should open
	},
	data: { // data, like loading indicator, later also partly json
		map_loaded: false, // indicates if the svg map is loaded
		json_loaded: false // indicates if the json data is loaded (from static, or dev endpoint)
	},
	intern: {
		is_initial_config_request_done: false, // check if the initial request is done, prevent flickering modal and prevent rerender
		is_authenticated: false, // user is logged in and staff member
	},
	intern_ui: { // panels and modals
		//@TODO: as we do not auto zoom or move, we do not need panel_height?
		panel_left_open: false,
		modal_color_open: false,
		modal_origin_destination_open: false
	},
	intern_config: { // some settings for the intern tool
		show_small_station_labels: true,
		show_medium_station_labels: true,
		show_large_station_labels: true,
		show_line_labels: true,
		override_color_bg: null, // automatic reset if the modal is closed, see reducer
		override_color_label: null,
		mode: 'default', // can be: default, origin_destination, color, handled upon modal states, no action, see reducer below
		origin_station_code: null, // if mode is origin_destination and a origin is choosen this is not null
		reset_trigger: Date.now() // used to detect if the reset button is pressed
	}
}

function react_app_reducer(state = initial_state, action) {
	switch (action.type) {
		case LOADER_GLOBAL_SHOW:
			const new_show_count = state.ui.loader_global_show_count + 1
			return Object.assign({}, state, {
				ui: {
					...state.ui,
					loader_global_show_count: new_show_count
				}
			});
		case LOADER_GLOBAL_HIDE:
			let new_hide_count = state.ui.loader_global_show_count - 1
			if(new_hide_count < 0) {
				new_hide_count = 0;
			}
			return Object.assign({}, state, {
				ui: {
					...state.ui,
					loader_global_show_count: new_hide_count
				}
			});
		case TOGGLE_PANEL_DETAIL_OPEN:
			return Object.assign({}, state, {
				panels: {
					...state.panels,
					panel_detail_open: action.panel_detail_open
				}
			});
		case TOGGLE_PANEL_DETAIL_IS_OPEN:
			return Object.assign({}, state, {
				panels: {
					...state.panels,
					panel_detail_is_open: action.panel_detail_is_open,
					panel_detail_space: action.panel_detail_space
				}
			});		
		case TOGGLE_PANEL_LEFT_OPEN:
			return Object.assign({}, state, {
				panels: {
					...state.panels,
					panel_left_open: action.panel_left_open
				}
			});
		case TOGGLE_PANEL_LEFT_IS_OPEN:
			return Object.assign({}, state, {
				panels: {
					...state.panels,
					panel_left_is_open: action.panel_left_is_open,
					panel_left_space: action.panel_left_space
				}
			});
        case TOGGLE_PANEL_DETAIL_CONTENT_IS_OPEN:
			return Object.assign({}, state, {
				panels: {
					...state.panels,
					panel_detail_content_is_open: action.panel_detail_content_is_open
				}
			});
        case TOGGLE_PANEL_START_OVERLAY_OPEN:
			return Object.assign({}, state, {
				panels: {
					...state.panels,
					panel_start_overlay_open: action.panel_start_overlay_open
				}
			});
        case TOGGLE_PANEL_START_OVERLAY_IS_OPEN:
			return Object.assign({}, state, {
				panels: {
					...state.panels,
					panel_start_overlay_is_open: action.panel_start_overlay_is_open
				}
			});
        case TOGGLE_PANEL_FULL_OVERLAY_AUTOCOMPLETE_NORESULT_IS_OPEN:
			return Object.assign({}, state, {
				panels: {
					...state.panels,
					panel_full_overlay_autocomplete_noresult_is_open: action.panel_full_overlay_autocomplete_noresult_is_open
				}
			});
		case SET_PANEL_HEADER_HEIGHT:
			return Object.assign({}, state, {
				panels: {
					...state.panels,
					panel_header_height: action.panel_header_height
				}
			});

		case TOGGLE_INSTANCE_AUTOCOMPLETE_MAIN_HEADER_OPEN:
			return Object.assign({}, state, {
				instances_open: {
					...state.instances_open,
					autocomplete_main_header: action.autocomplete_main_header_open
				}
			});
		case TOGGLE_INSTANCE_AUTOCOMPLETE_PANEL_LEFT_OPEN:
			return Object.assign({}, state, {
				instances_open: {
					...state.instances_open,
					autocomplete_panel_left: action.autocomplete_panel_left_open
				}
			});
		case TOGGLE_INSTANCE_AUTOCOMPLETE_START_OVERLAY_OPEN:
			return Object.assign({}, state, {
				instances_open: {
					...state.instances_open,
					autocomplete_start_overlay: action.autocomplete_start_overlay_open
				}
			});
		case TOGGLE_INSTANCE_AUTOCOMPLETE_PANEL_DETAIL_STATION_OPEN:
			return Object.assign({}, state, {
				instances_open: {
					...state.instances_open,
					autocomplete_panel_detail_station: action.autocomplete_panel_detail_station_open
				}
			});


		case RESIZE_WINDOW:
			return Object.assign({}, state, {
				ui: {
					...state.ui,
					window_width: action.width,
					window_height: action.height,
					client_type: action.client_type
				}
			});
		case ORIENTATION_CHANGE:
			return Object.assign({}, state, {
				ui: {
					...state.ui,
					orientation: action.orientation
				}
			});
		case SET_MAP_LOADED:
			return Object.assign({}, state, {
				data: {
					...state.data,
					map_loaded: true
				}
			});
		case SET_MAP_UNLOADED:
			return Object.assign({}, state, {
				data: {
					...state.data,
					map_loaded: false
				}
			});
		case SET_JSON_LOADED:
			return Object.assign({}, state, {
				data: {
					...state.data,
					json_loaded: true
				}
			});
		
		case INTERN_SET_IS_INITIAL_CONFIG_REQUEST_DONE:
			return Object.assign({}, state, {
				intern: {
					...state.intern,
					is_initial_config_request_done: true
				}
			});
		case INTERN_SET_IS_AUTHENTICATED:
			return Object.assign({}, state, {
				intern: {
					...state.intern,
					is_authenticated: action.is_authenticated
				}
			});
		case INTERN_TOGGLE_PANEL_LEFT_OPEN:
			return Object.assign({}, state, {
				intern_ui: {
					...state.intern_ui,
					panel_left_open: action.panel_left_open
				}
			});
		case INTERN_TOGGLE_MODAL_COLOR_OPEN:
			return {
		        ...state,
		        intern_ui: {
		            ...state.intern_ui,
		            modal_origin_destination_open: false,
		            modal_color_open: action.modal_color_open
		        },
		        intern_config: {
		            ...state.intern_config,
		            mode: action.modal_color_open ? 'color' : 'default'
		        }
		    };
		case INTERN_TOGGLE_MODAL_ORIGIN_DESTINATION_OPEN:
			return {
		        ...state,
		        intern_ui: {
		            ...state.intern_ui,
		            modal_color_open: false,
		            modal_origin_destination_open: action.modal_origin_destination_open
		        },
		        intern_config: {
		            ...state.intern_config,
		            mode: action.modal_origin_destination_open ? 'origin_destination' : 'default',
		            origin_station_code: null
		        }
		    };
		    
		case INTERN_TOGGLE_SHOW_SMALL_STATION_LABELS:
			return Object.assign({}, state, {
				intern_config: {
					...state.intern_config,
					show_small_station_labels: action.show_small_station_labels
				}
			});
		case INTERN_TOOGLE_SHOW_MEDIUM_STATION_LABELS:
			return Object.assign({}, state, {
				intern_config: {
					...state.intern_config,
					show_medium_station_labels: action.show_medium_station_labels
				}
			});	
		case INTERN_TOGGLE_SHOW_LARGE_STATION_LABELS:
			return Object.assign({}, state, {
				intern_config: {
					...state.intern_config,
					show_large_station_labels: action.show_large_station_labels
				}
			});	
		case INTERN_TOGGLE_SHOW_LINE_LABELS:
			return Object.assign({}, state, {
				intern_config: {
					...state.intern_config,
					show_line_labels: action.show_line_labels
				}
			});	
		case INTERN_TOGGLE_OVERRIDE_COLOR:
			return Object.assign({}, state, {
				intern_config: {
					...state.intern_config,
					override_color_bg: action.override_color_bg,
					override_color_label: action.override_color_label
				}
			});	
		case INTERN_SET_ORIGIN_STATION_CODE:
			return Object.assign({}, state, {
				intern_config: {
					...state.intern_config,
					origin_station_code: action.origin_station_code
				}
			});	
			
		case INTERN_RESET_ALL:
			return {
		        ...state,
		        intern_ui: {
		            ...state.intern_ui,
		            modal_color_open: false,
		            modal_origin_destination_open: false
		        },
		        intern_config: {
		            ...state.intern_config,
		            override_color_bg: null,
		            override_color_label: null,
		            show_small_station_labels: true,
		            show_medium_station_labels: true,
		            show_large_station_labels: true,
		            show_line_labels: true,
		            mode: 'default',
		            reset_trigger: Date.now()
		        }
		    };
		
	    default:
			return state
	}
}

const history = createBrowserHistory()

const { 
    routerMiddleware,
    routerReducer,
    createReduxHistory 
} = createReduxHistoryContext({ history: history });

const middlewares = [routerMiddleware]

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
	combineReducers({
		router: routerReducer,
		general: react_app_reducer
	}),
	composeEnhancers(
		applyMiddleware(...middlewares)
	)
)

const app_history = createReduxHistory(store);

export { store, app_history }

